import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { NgxsModule } from '@ngxs/store';
import { UserState } from './core/shared/states/user.state';
import { ApplicationState } from './core/shared/states/application.state';
import { GroupState } from './core/shared/states/group.state';
import { TokenState } from './core/shared/states/token.state';
import {  ChannelState } from './core/shared/states/channel.state';
import { membersState } from './core/shared/states/members.state';
import { applicationUserState } from './core/shared/states/application.user.state';
import { GroupAssignmentState } from './core/shared/states/group.assignment.state';
import { adminState } from './core/shared/states/admin.state';


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(NgxsModule.forRoot([
        UserState,
        ApplicationState,
        GroupState,
        TokenState,
        ChannelState,
        membersState,
        GroupAssignmentState,
        adminState,
        applicationUserState,
      ]))
  ]
};
